import { render, staticRenderFns } from "./questionModal.vue?vue&type=template&id=1a1a7f62&scoped=true&"
import script from "./questionModal.vue?vue&type=script&lang=js&"
export * from "./questionModal.vue?vue&type=script&lang=js&"
import style0 from "./questionModal.vue?vue&type=style&index=0&id=1a1a7f62&lang=less&scoped=true&"
import style1 from "./questionModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a7f62",
  null
  
)

export default component.exports